/**
 * Smooth in-page scrolling with fixed-header offset for Matcha anchor links.
 */
function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function getHeaderOffset() {
  const header = document.getElementById('header-component');
  if (!header) return 24;
  return Math.ceil(header.getBoundingClientRect().height) + 24;
}

function scrollToAnchor(targetId) {
  const target = document.getElementById(targetId);
  if (!target) return false;

  const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
  window.scrollTo({
    top: Math.max(top, 0),
    behavior: prefersReducedMotion() ? 'auto' : 'smooth',
  });

  if (typeof target.focus === 'function') {
    target.focus({ preventScroll: true });
  }

  return true;
}

function handleAnchorClick(event) {
  const trigger = event.target.closest('[data-matcha-scroll-to], a[href^="#"]');
  if (!trigger) return;

  let targetId = trigger.dataset.matchaScrollTo;

  if (!targetId && trigger.matches('a[href^="#"]')) {
    const hash = trigger.getAttribute('href');
    if (!hash || hash === '#') return;
    targetId = hash.slice(1);
  }

  if (!targetId) return;

  const target = document.getElementById(targetId);
  if (!target) return;

  event.preventDefault();
  scrollToAnchor(targetId);
}

if (!window.__matchaAnchorScrollInit) {
  window.__matchaAnchorScrollInit = true;
  document.addEventListener('click', handleAnchorClick);
}

export { scrollToAnchor };
